<nb-card>
  <nb-card-header>
    <div class="title">
      {{mode}} subscription plan
    </div>
  </nb-card-header>
  <nb-card-body>
    <div [formGroup]="subscriptionForm" class="container">

      <input type="hidden" id="planType" formControlName="planType" />

      <div class="column">
        <div class="form-group">
          <label for="planName">Plan Name</label>
          <input nbInput id="planName" formControlName="planName"
            [status]="(planName?.errors?.required || planName?.hasError('minlength') || planName?.hasError('maxlength')) && planName.touched ? 'danger' : 'primary'"
            class="form-control" placeholder="Plan Name">
          <ngx-validation-message label="Plan Name" [showRequired]="planName?.errors?.required  && planName.touched"
            [showMinLength]="planName?.hasError('minlength') && planName.touched"
            [showMaxLength]="planName?.hasError('maxlength') && planName.touched" minLength=3 maxLength=20>
          </ngx-validation-message>
        </div>

        <div class="form-group">
          <label for="planCode">Plan Code</label>
          <input nbInput id="planCode" formControlName="planCode"
            [status]="(planCode?.errors?.required || planCode?.hasError('minlength') || planCode?.hasError('maxlength')) && planCode.touched ? 'danger' : 'primary'"
            class="form-control" placeholder="Plan Code">
          <ngx-validation-message label="Plan Code" [showRequired]="planCode?.errors?.required  && planCode.touched"
            [showMinLength]="planCode?.hasError('minlength') && planCode.touched"
            [showMaxLength]="planCode?.hasError('maxlength') && planCode.touched" minLength=3 maxLength=20>
          </ngx-validation-message>
        </div>

        <div class="form-group">
          <label for="priceId">Price Id</label>
          <input nbInput id="priceId" formControlName="priceId"
            [status]="(priceId?.errors?.required || priceId?.hasError('minlength') || priceId?.hasError('maxlength')) && priceId.touched ? 'danger' : 'primary'"
            class="form-control" placeholder="Price Id">
          <ngx-validation-message label="Plan Code" [showRequired]="priceId?.errors?.required  && priceId.touched"
            [showMinLength]="priceId?.hasError('minlength') && priceId.touched"
            [showMaxLength]="priceId?.hasError('maxlength') && priceId.touched" minLength=3 maxLength=40>
          </ngx-validation-message>
        </div>

        <div class="form-group">
          <label for="price">Price</label>
          <input nbInput class="form-control" id="price" formControlName="price" type="number"
            [status]="(price?.errors?.required || price?.errors?.min || price?.errors?.max || price?.hasError('pattern')) && price.touched ? 'danger' : 'primary'"
            placeholder="Price">
          <ngx-validation-message label="Price" [showRequired]="price?.errors?.required && price.touched"
            [showMin]="price?.errors?.min && price.touched" [showMax]="price?.errors?.max && price.touched"
            [showPattern]="price?.hasError('pattern') && price.touched" min=1 max=99999>
          </ngx-validation-message>
        </div>

        <div class="form-group">
          <label for="patientsCount">Clients Count</label>
          <input nbInput class="form-control" id="patientsCount" formControlName="patientsCount" type="number"
            [status]="(patientsCount?.errors?.required || patientsCount?.errors?.min || patientsCount?.errors?.max || patientsCount?.hasError('pattern')) && patientsCount.touched ? 'danger' : 'primary'"
            placeholder="Patients Count">
          <ngx-validation-message label="Clients Count"
            [showRequired]="patientsCount?.errors?.required && patientsCount.touched"
            [showMin]="patientsCount?.errors?.min && patientsCount.touched"
            [showMax]="patientsCount?.errors?.max && patientsCount.touched"
            [showPattern]="patientsCount?.hasError('pattern') && price.touched" min=-1 max=99999>
          </ngx-validation-message>
        </div>

        <div class="form-group">
          <label for="isFreePlan">Settings</label>
          <nb-checkbox id="isFreePlan" formControlName="isFreePlan" class="form-control" placeholder="Free Plan">Free
            Plan</nb-checkbox>
          <nb-checkbox id="hasAssessments" formControlName="hasAssessments" class="form-control"
            placeholder="Has CheckIn">Has CheckIn</nb-checkbox>
          <nb-checkbox id="hasBranding" formControlName="hasBranding" class="form-control" placeholder="Has Branding">
            Has Branding</nb-checkbox>
          <nb-checkbox id="hasPlanChoices" formControlName="hasPlanChoices" class="form-control"
            placeholder="Has Plan Choices">Has Plan Choices</nb-checkbox>
        </div>

        <div class="form-group">
        </div>

        <div class="form-group">
        </div>

        <div class="form-group">
        </div>

      </div>

    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton  [disabled]="!subscriptionForm.valid" (click)="save()">Submit</button>
    <button nbButton status="info" (click)="back()">Back</button>
  </nb-card-footer>
</nb-card>
